import { Controller } from 'stimulus';

class PlayerController extends Controller {
  connect() {
    import(/* webpackChunkName: "plyr" */ 'plyr').then((module) => {
      const Plyr = module.default;
      this.player = new Plyr(this.mediaTarget);
    });
  }

  disconnect() {
    if (this.player) {
      this.player.destroy();
    }
  }
}

PlayerController.targets = [
  'media',
];

export default PlayerController;
